/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { tool_pairing_draft } from '../models/tool_pairing_draft';
import type { tool_pairing_draft_dto } from '../models/tool_pairing_draft_dto';
import type { tool_pairing_draw } from '../models/tool_pairing_draw';
import type { tool_pairing_draw_create_dto } from '../models/tool_pairing_draw_create_dto';
import type { tool_pairing_draw_dto } from '../models/tool_pairing_draw_dto';
import type { tool_pairing_draw_select_dto } from '../models/tool_pairing_draw_select_dto';
import type { tool_pairing_draw_selected } from '../models/tool_pairing_draw_selected';
import type { tool_pairing_match } from '../models/tool_pairing_match';
import type { tool_pairing_team } from '../models/tool_pairing_team';
import type { tool_pairing_team_draw } from '../models/tool_pairing_team_draw';
import type { tool_pairing_team_dto } from '../models/tool_pairing_team_dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ToolPairingService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Create the draft
   * @returns tool_pairing_draft successful
   * @throws ApiError
   */
  public createDraft({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: tool_pairing_draft_dto;
  }): CancelablePromise<tool_pairing_draft> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/tool/pairing/drafts',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get a Draw
   * @returns tool_pairing_team_draw successful
   * @throws ApiError
   */
  public getDraw({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * DraftTeam identifier
     */
    id: string;
  }): CancelablePromise<tool_pairing_team_draw> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tool/pairing/teams/{id}/draws',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Create a Draw
   * @returns tool_pairing_draw successful
   * @throws ApiError
   */
  public createDraw({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * DraftTeam identifier
     */
    id: string;
    requestBody?: tool_pairing_draw_create_dto;
  }): CancelablePromise<tool_pairing_draw> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/tool/pairing/teams/{id}/draws',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Update a Draw
   * @returns tool_pairing_draw successful
   * @throws ApiError
   */
  public updateDraw({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Draw identifier
     */
    id: string;
    requestBody?: tool_pairing_draw_dto;
  }): CancelablePromise<tool_pairing_draw> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/tool/pairing/draws/{id}',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Select an army in the opponent Draw
   * @returns tool_pairing_draw_selected successful
   * @throws ApiError
   */
  public selectArmyInDraw({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Draw identifier
     */
    id: string;
    requestBody?: tool_pairing_draw_select_dto;
  }): CancelablePromise<tool_pairing_draw_selected> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/tool/pairing/draws/{id}/select',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get matches for a draft
   * @returns tool_pairing_match successful
   * @throws ApiError
   */
  public getMatches({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Draft identifier
     */
    id: string;
  }): CancelablePromise<Array<tool_pairing_match>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tool/pairing/drafts/{id}/matches',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Get a team
   * @returns tool_pairing_team successful
   * @throws ApiError
   */
  public getTeam({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * DraftTeam identifier
     */
    id: string;
  }): CancelablePromise<tool_pairing_team> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tool/pairing/teams/{id}',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Update a team
   * @returns tool_pairing_team successful
   * @throws ApiError
   */
  public updateTeam({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * DraftTeam identifier
     */
    id: string;
    requestBody?: tool_pairing_team_dto;
  }): CancelablePromise<tool_pairing_team> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/tool/pairing/teams/{id}',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get Draft by the team
   * @returns tool_pairing_draft successful
   * @throws ApiError
   */
  public getDraftByTeam({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * DraftTeam identifier
     */
    id: string;
  }): CancelablePromise<tool_pairing_draft> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tool/pairing/teams/{id}/draft',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
}
